import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import {
  Button,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import {
  USERS_URL,
  ROLES_ASEGURADO,
  ROLES_CORREDOR,
  ROLES_ASEGURADO_CREDITO,
  ROLES_ASEGURADO_GARANTIA,
  ROLES_CORREDOR_CREDITO,
  ROLES_CORREDOR_GARANTIA,
  DOCS_URL,
  POLICY_URL,
  ACCOUNTANT_URL,
  RISK_URL,
  ANALYST_URL,
  REASEGURO_URL,
  ROLES_CORREDOR_COMISIONES,
  SINIESTROS_URL,
  ORSAN_LOGO_URL,
  PROFILES
} from 'CONST';
import { signout } from 'helpers/auth';
import getUserHome from 'helpers/routeHelper'
import 'styles/navbar.css';
import { userHasRole } from '../../helpers/helpers';
import isUserHasProfile from '../../helpers/profileValidator';
import NotificationBell from '../shared/NotificationBell';
import FAQModal from '../shared/FAQModal';

class BaseNavbar extends Component {
  state = {
    faqOpen: false,
  };
  toggleFAQ = () => {
    this.setState(prev => ({ faqOpen: !prev.faqOpen }));
  };
  redirectWithToken = (event) => {
    event.preventDefault();
    const { token } = this.props;

    const url = event.target.href;

    const options = {
      method: 'GET',
      headers: {
        'X-JWT-TOKEN': token,
      },
      credentials: 'include',
    };

    fetch(url, options)
      .then((response) => {
        if (response.ok) {
          window.location.href = url;
        }
      })
      .catch(() => {});
  }

  handleSignOut = (event) => {
    event.preventDefault();
    signout();
  };

  getSelectedClass = (path, exact = false) => {
    const currentPath = window.location.pathname;

    const { user } = this.props;

    // Maneja un arreglo the "paths"
    if (Array.isArray(path)) {
      if (path.some(p => exact ? currentPath === p : currentPath.startsWith(p)))
        return 'nav-selected';
    }

    if (typeof path === 'string') {
      if (exact ? currentPath === path : currentPath.startsWith(path))
        return 'nav-selected';
    }

    if (currentPath === "/" && user) {
      const { path: homePath } = getUserHome(user);

      // Maneja el "home path"
      if (Array.isArray(path) ? path.includes(homePath) : homePath === path)
        return 'nav-selected';
    }

    return '';
  };

  render() {
    const { user } = this.props;
    
    if (!user.email) {
      return null;
    }

    return (
      <nav className="navbar-content">
        <div className="nav-logo-container">
          <Link to="/users">
            <img src={ORSAN_LOGO_URL} className="nav-logo" alt="" />
          </Link>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
          <ul className="nav-links-group">
            {user.apps.length > 1 ? (
              <UncontrolledDropdown nav className="nav-link-element">
                <DropdownToggle nav caret className="navbar-header">
                  SEGURO DE CRÉDITO
                </DropdownToggle>
                <DropdownMenu>
                  {user.apps.includes('users') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={USERS_URL}>
                        USUARIOS
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('docs') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={DOCS_URL}>
                        DOCUMENTOS
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('policies') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={POLICY_URL}>
                        PÓLIZA
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('accountant') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={ACCOUNTANT_URL}>
                        RESERVAS
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('reaseguro') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={REASEGURO_URL}>
                        REASEGURO
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('risk') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={RISK_URL}>
                        RIESGO
                      </a>
                    </DropdownItem>
                  )}
                  {user.apps.includes('analista') && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={ANALYST_URL}>
                        RIESGO DE CRÉDITO
                      </a>
                    </DropdownItem>
                  )}
                  {user.is_orsan && (
                    <DropdownItem>
                      <a className="nav-link navbar-header" href={SINIESTROS_URL} onClick={this.redirectWithToken}>
                        SINIESTROS
                      </a>
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            ) : (
              <li className="nav-link-element">
                <Link className="navbar-header nav-link" to="/">
                  SEGURO DE CRÉDITO
                </Link>
              </li>
            )}
            {/* Es asegurado únicamente, no es corredor */}
            {userHasRole(user, ROLES_ASEGURADO) && !userHasRole(user, ROLES_CORREDOR) && (
              <>
                <li className="nav-link-element nav-item">
                  <Link className={`nav-link nav-pill ${this.getSelectedClass('/asegurado/lineas-credito')}`} to="/asegurado/lineas-credito">
                    Mi Cartera
                  </Link>
                </li>
                <li className="nav-link-element nav-item">
                  <Link className={`nav-link nav-pill ${this.getSelectedClass('/asegurado/polizas-credito')}`} to="/asegurado/polizas-credito">
                    Mi Póliza
                  </Link>
                </li>
                {(isUserHasProfile([PROFILES.externoAdministradorAseguradoCredito])) && (
                <UncontrolledDropdown nav className="nav-link-element">
                  <DropdownToggle nav caret className={`nav-pill ${this.getSelectedClass('/asegurado/libros-venta')}`}>
                    Otras Acciones
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>
                      <Link className={`nav-link ${this.getSelectedClass('/asegurado/libros-venta')}`} to="/asegurado/libros-venta">
                        Libros de Venta
                      </Link>
                    </DropdownItem>
                      <DropdownItem>
                        <Link 
                          className={`nav-link ${this.getSelectedClass('/prorroga/solicitud-prorroga')}`} 
                          to="/prorroga/solicitud-prorroga/redirect"
                        >
                          Solicitud Prórroga
                        </Link>
                      </DropdownItem>
                      {user.is_orsan && (
                      <DropdownItem>
                        <Link 
                          className={`nav-link ${this.getSelectedClass('/prorroga/solicitudes-prorroga')}`} 
                          to="/prorroga/solicitudes-prorroga"
                        >
                          Ver Prórrogas
                        </Link>
                      </DropdownItem>
                      )}
                      <DropdownItem>
                        <a
                          className="nav-link" 
                          href={`${SINIESTROS_URL}denuncia-credito`}
                          onClick={this.redirectWithToken}
                        >
                          Denunciar Siniestro
                        </a>
                      </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                )}
              </>
            )}
            {/* Es corredor únicamente, no es asegurado */}
            {userHasRole(user, ROLES_CORREDOR) && !userHasRole(user, ROLES_ASEGURADO) && (
              <>
                <UncontrolledDropdown nav className="nav-link-element">
                  <DropdownToggle nav caret className={`nav-pill ${this.getSelectedClass([
                    '/corredor/polizas-credito',
                    '/corredor/polizas-garantia',
                    '/corredor/lineas-garantia',
                    '/corredor/produccion-mensual',
                    '/prorroga/solicitud-prorroga'
                  ])}`}>
                    Corredores
                  </DropdownToggle>
                  <DropdownMenu>
                    {userHasRole(user, ROLES_CORREDOR_CREDITO) && (
                      <>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/corredor/polizas-credito')}`} to="/corredor/polizas-credito">
                            Pólizas Crédito
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link 
                            className={`nav-link ${this.getSelectedClass('/prorroga/solicitud-prorroga')}`} 
                            to="/prorroga/solicitud-prorroga/redirect"
                          >
                            Ver Prorrogas
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <a className={`nav-link ${this.getSelectedClass('/siniestros')}`} href={`${SINIESTROS_URL}denuncia-credito`} onClick={this.redirectWithToken}>
                            Ver Siniestros
                          </a>
                        </DropdownItem>
                      </>
                    )}
                    {/*
                    {userHasRole(user, ROLES_CORREDOR_GARANTIA) && (
                      <>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/corredor/polizas-garantia')}`} to="/corredor/polizas-garantia">
                            Pólizas Garantía
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/corredor/lineas-garantia')}`} to="/corredor/lineas-garantia">
                            Líneas Garantía
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/corredor/produccion-mensual')}`} to="/corredor/produccion-mensual">
                            Producción Mensual Garantía
                          </Link>
                        </DropdownItem>
                      </>
                    )} */}
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav className="nav-link-element">
                  <DropdownToggle nav caret className={`nav-pill ${this.getSelectedClass('/asegurado')}`}>
                    Asegurados
                  </DropdownToggle>
                  <DropdownMenu>
                    {userHasRole(user, ROLES_CORREDOR_CREDITO) && (
                      <>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/asegurado/polizas-credito')}`} to="/asegurado/polizas-credito">
                            Pólizas Crédito
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/asegurado/lineas-credito')}`} to="/asegurado/lineas-credito">
                            Líneas Crédito
                          </Link>
                        </DropdownItem>
                      </>
                    )}
                    {/*
                    {userHasRole(user, ROLES_CORREDOR_GARANTIA) && (
                      <>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/asegurado/polizas-garantia')}`} to="/asegurado/polizas-garantia">
                            Pólizas Garantía
                          </Link>
                        </DropdownItem>
                      </>
                    )}
                      */}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </>
            )}
            {/* Es asegurado y corredor */}
            {userHasRole(user, ROLES_CORREDOR) && userHasRole(user, ROLES_ASEGURADO) && (
              <>
                {userHasRole(user, ROLES_ASEGURADO) && (
                  <li className="nav-link-element nav-item dropdown">
                    <Link
                      className={`nav-link nav-pill ${this.getSelectedClass('/resumen')}`}
                      to="/resumen"
                    >
                      Resumen
                    </Link>
                  </li>
                )}
                <UncontrolledDropdown nav className="nav-link-element">
                  <DropdownToggle
                    nav
                    caret
                    className={`nav-pill ${this.getSelectedClass('/asegurado')}`}
                  >
                    Asegurados
                  </DropdownToggle>
                  <DropdownMenu>
                    {userHasRole(user, ROLES_ASEGURADO_CREDITO) && (
                      <>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/asegurado/polizas-credito')}`} to="/asegurado/polizas-credito">
                            Pólizas Crédito
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/asegurado/lineas-credito')}`} to="/asegurado/lineas-credito">
                            Líneas Crédito
                          </Link>
                        </DropdownItem>
                        {/* <DropdownItem>
                          <Link className="nav-link" to="/asegurado/consolidado-credito">
                            Consolidado Crédito
                          </Link>
                        </DropdownItem> */}
                      </>
                    )}
                    {userHasRole(user, ROLES_ASEGURADO_GARANTIA) && (
                      <>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/asegurado/polizas-garantia')}`} to="/asegurado/polizas-garantia">
                            Pólizas Garantía
                          </Link>
                        </DropdownItem>
                        {!user.is_orsan && (
                          <DropdownItem>
                            <Link className={`nav-link ${this.getSelectedClass('/asegurado/linea-garantia')}`} to="/asegurado/linea-garantia">
                              Líneas Garantía
                            </Link>
                          </DropdownItem>
                        )}
                      </>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown nav className="nav-link-element">
                  <DropdownToggle
                    nav
                    caret
                    className={`nav-pill ${this.getSelectedClass(
                      [
                        '/corredor/polizas-credito',
                        '/corredor/polizas-garantia',
                        '/corredor/lineas-garantia',
                        '/corredor/produccion-mensual',
                      ],
                      true
                    )}`}
                  >
                    Corredores
                  </DropdownToggle>
                  <DropdownMenu>
                    {userHasRole(user, ROLES_CORREDOR_CREDITO) && (
                      <DropdownItem>
                        <Link className={`nav-link ${this.getSelectedClass('/corredor/polizas-credito')}`} to="/corredor/polizas-credito">
                          Pólizas Crédito
                        </Link>
                      </DropdownItem>
                    )}
                    {userHasRole(user, ROLES_CORREDOR_GARANTIA) && (
                      <>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/corredor/polizas-garantia')}`} to="/corredor/polizas-garantia">
                            Pólizas Garantía
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/corredor/lineas-garantia')}`} to="/corredor/lineas-garantia">
                            Líneas Garantía
                          </Link>
                        </DropdownItem>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/corredor/produccion-mensual')}`} to="/corredor/produccion-mensual">
                            Producción Mensual Garantía
                          </Link>
                        </DropdownItem>
                      </>
                    )}
                    {userHasRole(user, ROLES_CORREDOR_CREDITO) && (
                        <DropdownItem>
                          <a
                            className="nav-link" 
                            href={`${SINIESTROS_URL}denuncia-credito`}
                            onClick={this.redirectWithToken}
                          >
                            Denunciar Siniestro
                          </a>
                        </DropdownItem>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </>
            )}
            {/* Es corredor (intermediario) comisiones */}
            {userHasRole(user, ROLES_CORREDOR_COMISIONES) && (
              <UncontrolledDropdown nav className="nav-link-element">
                  <DropdownToggle
                    nav
                    caret
                    className={`nav-pill ${this.getSelectedClass(
                      [
                        '/corredor/liquidacion-credito',
                        '/corredor/liquidacion-garantia',
                      ],
                    )}`}
                  >
                  Comisiones
                </DropdownToggle>
                <DropdownMenu>
                  {userHasRole(user, ROLES_CORREDOR_CREDITO) && (
                    <>
                      <DropdownItem>
                        <Link className={`nav-link ${this.getSelectedClass('/corredor/liquidacion-credito')}`} to="/corredor/liquidacion-credito">
                          Liquidación Crédito
                        </Link>
                      </DropdownItem>
                    </>
                  )}
                  {/* 
                    {userHasRole(user, ROLES_CORREDOR_GARANTIA) && (
                      <>
                        <DropdownItem>
                          <Link className={`nav-link ${this.getSelectedClass('/corredor/liquidacion-garantia')}`} to="/corredor/liquidacion-garantia">
                            Liquidación Garantía
                          </Link>
                        </DropdownItem>
                      </>
                    )}
                  */}
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
            {user.is_orsan && (
              <UncontrolledDropdown nav className="nav-link-element">
                <DropdownToggle
                  nav
                  caret
                  className={`nav-pill ${this.getSelectedClass('/operaciones', false)}`}
                >
                  Operaciones
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>
                    <Link className={`nav-link ${this.getSelectedClass('/operaciones/libros-venta')}`} to="/operaciones/libros-venta">
                      Libros de Venta
                    </Link>
                  </DropdownItem>
                  <DropdownItem>
                    <Link className={`nav-link ${this.getSelectedClass('/operaciones/liquidaciones-credito')}`} to="/operaciones/liquidaciones-credito">
                      Liquidación Crédito
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>

            )}
            {user.is_orsan && (
              <UncontrolledDropdown nav className="nav-link-element">
                <DropdownToggle
                  nav
                  caret
                  className={`nav-pill ${this.getSelectedClass(['/prorroga', '/solicitudes-prorroga'], false)}`}
                >
                  Prórrogas
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>
                    <Link 
                      className={`nav-link ${this.getSelectedClass('/prorroga/solicitudes-prorroga')}`} 
                      to="/prorroga/solicitudes-prorroga"
                    >
                      Ver Prórrogas
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
          </ul>
          <ul className="nav-links-group">
            <li className="nav-link-element nav-item dropdown">
              <Button
                color="primary"
                className="mr-3"
                onClick={this.toggleFAQ}
                title="Centro de ayuda y tutoriales" // Tooltip nativo
              >
                <FontAwesomeIcon icon={faQuestionCircle} size="1x" />
              </Button>
              <FAQModal
                open={this.state.faqOpen}
                toggle={this.toggleFAQ}
              />
            </li>
            <li className="nav-link-element nav-ite">
              <NotificationBell />
            </li>
            <li className="nav-link-element nav-ite dropdown">
              <p className="nav-link">{user.username || ''}</p>
            </li>
            <li className="nav-link-element nav-item dropdown">
              <Button className="btn-outline-orsan-logout mr-3" onClick={this.handleSignOut}>
                Cerrar Sesión
                <FontAwesomeIcon icon={faSignOutAlt} size="1x" className="ml-2" />
              </Button>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

BaseNavbar.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    username: PropTypes.string,
    full_name: PropTypes.string,
    has_access: PropTypes.bool,
    apps: PropTypes.arrayOf(PropTypes.string),
    organization: PropTypes.number,
    sub: PropTypes.string,
    roles: PropTypes.array,
    is_orsan: PropTypes.bool,
  }).isRequired,
  token: PropTypes.string,
};

BaseNavbar.defaultProps = {
  token: undefined,
};

const mapStateToProps = (state) => ({
  user: state.login.user,
  token: state.login.id_token,
});

export default withRouter(connect(mapStateToProps)(BaseNavbar));
